/**
 * LOP Search & Discovery Scripts
 * JavaScript para mejorar la funcionalidad de los filtros nativos
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // === Funcionalidad del formulario de rango de precios ===
  const priceRangeForms = document.querySelectorAll('.LOP-price-range-form');
  
  priceRangeForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const params = new URLSearchParams(window.location.search);
      
      // Actualizar parámetros de precio
      for (let [key, value] of formData.entries()) {
        if (value && value.trim() !== '') {
          // Convertir a centavos y validar
          const priceInCents = Math.floor(parseFloat(value) * 100);
          if (priceInCents >= 0) {
            params.set(key, priceInCents);
          }
        } else {
          params.delete(key);
        }
      }
      
      // Redirigir con nuevos parámetros
      window.location.search = params.toString();
    });
    
    // Validación en tiempo real
    const priceInputs = form.querySelectorAll('input[type="number"]');
    priceInputs.forEach(function(input) {
      input.addEventListener('blur', function() {
        const value = parseFloat(this.value);
        if (value < 0) {
          this.value = 0;
        }
      });
      
      // Permitir solo números y punto decimal
      input.addEventListener('keypress', function(e) {
        const char = String.fromCharCode(e.which);
        if (!/[0-9\.]/.test(char)) {
          e.preventDefault();
        }
      });
    });
  });
  
  // === Mejorar la experiencia de clic en filtros ===
  const filterLinks = document.querySelectorAll('.LOP-search-discovery-filters a, .LOP-search-discovery-popup a');
  
  filterLinks.forEach(function(link) {
    // Agregar clase de loading al hacer clic
    link.addEventListener('click', function(e) {
      // No interceptar si es el botón de limpiar precios
      if (this.classList.contains('remove-price-filter')) {
        return;
      }
      
      // Agregar indicador visual de carga
      const container = this.closest('.LOP-search-discovery-filters, .LOP-search-discovery-popup');
      if (container) {
        container.classList.add('loading');
      }
      
      // Opcional: mostrar spinner
      this.style.opacity = '0.6';
    });
  });
  
  // === Funcionalidad para cerrar filtros en móvil ===
  const closeFilterButtons = document.querySelectorAll('.close-filter');
  
  closeFilterButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const filterSidebar = document.querySelector('.filter-sidebar');
      const filterModal = this.closest('.nt_filter');
      
      if (filterSidebar) {
        filterSidebar.classList.remove('active');
      }
      
      if (filterModal) {
        filterModal.style.display = 'none';
      }
    });
  });
  
  // === Accordión para filtros en móvil ===
  function initMobileAccordion() {
    if (window.innerWidth <= 768) {
      const filterTitles = document.querySelectorAll('.LOP-search-discovery-filters .widget-title, .LOP-search-discovery-popup .widget-title');
      
      filterTitles.forEach(function(title) {
        if (!title.classList.contains('accordion-initialized')) {
          title.classList.add('accordion-initialized');
          title.style.cursor = 'pointer';
          
          title.addEventListener('click', function() {
            const widget = this.closest('.widget');
            const content = widget.querySelector('.entry-content');
            
            if (content) {
              const isExpanded = content.style.display !== 'none';
              content.style.display = isExpanded ? 'none' : 'block';
              
              // Añadir indicador visual
              if (isExpanded) {
                this.classList.add('collapsed');
              } else {
                this.classList.remove('collapsed');
              }
            }
          });
        }
      });
    }
  }
  
  // Ejecutar al cargar y redimensionar
  initMobileAccordion();
  window.addEventListener('resize', initMobileAccordion);
  
  // === Preservar scroll position después de filtrar ===
  function preserveScrollPosition() {
    // Guardar posición actual
    const scrollPosition = window.pageYOffset;
    sessionStorage.setItem('LOP_scroll_position', scrollPosition);
  }
  
  // Restaurar posición después de cargar
  const savedPosition = sessionStorage.getItem('LOP_scroll_position');
  if (savedPosition) {
    window.scrollTo(0, parseInt(savedPosition));
    sessionStorage.removeItem('LOP_scroll_position');
  }
  
  // Guardar posición antes de filtrar
  filterLinks.forEach(function(link) {
    link.addEventListener('click', preserveScrollPosition);
  });
  
  // === Mejorar accesibilidad ===
  function improveAccessibility() {
    // Agregar roles ARIA
    const filterSections = document.querySelectorAll('.LOP-search-discovery-filters, .LOP-search-discovery-popup');
    
    filterSections.forEach(function(section) {
      section.setAttribute('role', 'region');
      section.setAttribute('aria-label', 'Filtros de productos');
      
      // Mejorar navegación con teclado
      const filterLinks = section.querySelectorAll('a');
      filterLinks.forEach(function(link, index) {
        link.setAttribute('tabindex', '0');
        
        // Navegación con Enter y Space
        link.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
          }
        });
      });
    });
  }
  
  improveAccessibility();
  
  // === Analytics tracking (opcional) ===
  function trackFilterUsage(filterType, filterValue, action) {
    // Integrar con Google Analytics, Facebook Pixel, etc.
    if (typeof gtag !== 'undefined') {
      gtag('event', 'filter_interaction', {
        'filter_type': filterType,
        'filter_value': filterValue,
        'action': action,
        'page_location': window.location.href
      });
    }
    
    // Shopify Analytics
    if (typeof analytics !== 'undefined') {
      analytics.track('Product Filter Used', {
        filterType: filterType,
        filterValue: filterValue,
        action: action
      });
    }
  }
  
  // Rastrear clics en filtros
  filterLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      const widget = this.closest('.widget');
      const filterType = widget ? widget.querySelector('.widget-title').textContent.trim() : 'Unknown';
      const filterValue = this.textContent.trim();
      const action = this.href.includes('filter') ? 'add' : 'remove';
      
      trackFilterUsage(filterType, filterValue, action);
    });
  });
  
  console.log('LOP Search & Discovery filters initialized successfully');
});

// === Funciones auxiliares ===
window.LOP_SearchDiscovery = {
  // Función para refrescar filtros si es necesario
  refreshFilters: function() {
    console.log('Refreshing LOP Search & Discovery filters...');
    // Implementar lógica de refresco si es necesario
  },
  
  // Función para obtener filtros activos
  getActiveFilters: function() {
    const activeFilters = [];
    const chosenItems = document.querySelectorAll('.LOP-search-discovery-filters .chosen, .LOP-search-discovery-popup .chosen');
    
    chosenItems.forEach(function(item) {
      const link = item.querySelector('a');
      if (link) {
        activeFilters.push({
          text: link.textContent.trim(),
          url: link.href
        });
      }
    });
    
    return activeFilters;
  },
  
  // Función para limpiar todos los filtros
  clearAllFilters: function() {
    const resetButton = document.querySelector('.yith-wcan-reset-navigation');
    if (resetButton) {
      resetButton.click();
    }
  }
};
